import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';
import { missionPlannerQueryKeys } from './mission-planner.keys';

export const missionPlannerQueries = {
  benchmarkByPlanId: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getBenchmark(taskId),
      queryFn: () => api.missionPlanner.getBenchmarkById(taskId),
    }),
  routesByPlanId: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getPlans(taskId),
      queryFn: () => api.missionPlanner.getTaskById(taskId),
    }),
  partialRouteByPlanId: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getPlans(taskId),
      queryFn: () => api.missionPlanner.getPartialPlanById(taskId),
    }),
  surgeonRoutesByPlanId: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getSurgeonPlans(taskId),
      queryFn: () => api.missionPlanner.getSurgeonTripsById(taskId),
    }),
  commercialFlightsById: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getCommercialPlans(taskId),
      queryFn: () => api.missionPlanner.getCommercialFlightsById(taskId),
    }),
  partialCommercialFlightsById: (taskId: string) =>
    queryOptions({
      queryKey: missionPlannerQueryKeys.getCommercialPlans(taskId),
      queryFn: () => api.missionPlanner.getPartialCommercialFlightById(taskId),
    }),
};
